<template>
  <div class="relative">
    <div class="max-w-screen-xl mx-auto px-4 pt-6 pb-0 lg:pt-8">
      <h1 class="text-center uppercase">
        {{ component.customComponent.title }}
      </h1>
      <div
        class="flex flex-col lg:flex-row mt-4 lg:mt-8 justify-center items-center lg:items-start"
      >
        <h2
          class="w-full max-w-108 lg:w-1/2 lg:max-w-none mb-8 text-center lg:text-left text-2xl md:text-3xl lg:text-4xl bg-linear-to-r from-accent-gold to-accent-magenta bg-clip-text text-transparent drop-shadow-lg uppercase"
        >
          {{ component.customComponent.content }}
        </h2>
        <div
          class="relative w-full max-w-lg h-44 md:h-56 lg:w-1/2 lg:max-w-none lg:h-64"
        >
          <strapi-image
            v-for="image in component.customComponent.layoutImages"
            :key="image.id"
            :image="image.image"
            class="absolute"
            :style="styles[image.id]"
            :class="imagePositionClass(image.imageKey)"
            fluid
          />
        </div>
      </div>
    </div>

    <strapi-image
      class="absolute inset-0 w-full h-full object-cover -z-1"
      style="mask-image: linear-gradient(to bottom, rgb(0 0 0), rgb(0 0 0 / 0))"
      :image="component.customComponent.backgroundImage"
    />
  </div>
</template>

<script setup lang="ts">
import type { StrapiCustomComponent } from '~/apollo/types/types';

const props = defineProps<{
  component: StrapiCustomComponent;
}>();

const imagePositionClasses: Record<string, string> = {
  triangle1: 'top-2.5 left-0 w-3/5 h-auto',
  triangle2: 'top-2.5 right-5 w-1/2 h-auto',
  pacman: 'w-[35%] h-auto',
  gamepad: 'top-28 -right-2.5 w-[35%] h-auto',
};

const imagePositionClass = (key: string) => imagePositionClasses[key] ?? '';

const styles = reactive<Record<string, { transform: string }>>({});

const positions = ref<
  Record<string, { x: number; y: number; dx: number; dy: number }>
>({});

props.component.customComponent.layoutImages?.forEach((image) => {
  const speed = 0.5;
  positions.value[image.id] = {
    x: Math.random() * 20 - 10,
    y: Math.random() * 20 - 10,
    dx: (Math.random() * 0.4 + 0.1) * (Math.random() > 0.5 ? 1 : -1) * speed,
    dy: (Math.random() * 0.4 + 0.1) * (Math.random() > 0.5 ? 1 : -1) * speed,
  };
  styles[image.id] = {
    transform: `translate(${positions.value[image.id].x}px, ${positions.value[image.id].y}px)`,
  };
});

const animate = () => {
  Object.entries(positions.value).forEach(([id, p]) => {
    p.x += p.dx;
    p.y += p.dy;
    if (p.x > 20 || p.x < -20) p.dx *= -1;
    if (p.y > 20 || p.y < -20) p.dy *= -1;
    styles[id].transform = `translate(${p.x}px, ${p.y}px)`;
  });
  requestAnimationFrame(animate);
};

onMounted(animate);
</script>
